import React, { useEffect, useState } from "react";
import { FC } from "react";
import { Helmet } from "react-helmet";
import { useSearchParams, useNavigate } from "react-router-dom";
import { compteService } from '_services/compte.service';
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useTranslation } from "react-i18next";

export interface PageConfirmationEmailProps {
  className?: string;
}

const PageConfirmationEmail: FC<PageConfirmationEmailProps> = ({ className = "" }) => {
  
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
    const [messageErreur, setMessageErreur] = useState("");

  
const token = searchParams.get("token");
const email = searchParams.get("email");

useEffect(() => {

  const confirmerEmail = async () => {

    if (!token || !email) {
      setMessageErreur(t("emailLinkIncomplete"));
      setLoading(false);
      return;
    }

    try {

      const response = await compteService.confirmationEmail(email, token);

      if (response.data?.message === "EMAIL_CONFIRME") {
        setSuccess(true);
      } else {
        setMessageErreur(
          t("emailConfirmationFailed")
        );
      }

    } catch (error: any) {

      const message = error.response?.data?.message;

      if (message === "LIEN_INVALIDE") {
        setMessageErreur(
          t("emailLinkInvalid")
        );
      } else if (message === "PARAMETRES_MANQUANTS") {
        setMessageErreur(
          t("emailLinkIncomplete")
        );
      } else {
        setMessageErreur(
          t("emailConfirmationError")
        );
      }

    } finally {
      setLoading(false);
    }
  };

  confirmerEmail();

}, [token, email, t]);


  if (loading) {
  return (
  <div className={`nc-PageConfirmationEmail ${className}`} data-nc-id="PageConfirmationEmail">
      <Helmet>
        <title>{t('emailConfirmationTitle')}</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <div className="max-w-md mx-auto text-center space-y-3">
          <div>
            <br/>
            <br/>
           <p>
          {t('emailConfirmationLoading')}
        </p>
        <br/>
    
          </div>
   
        </div>
      </div>


    </div>);
  }

   if (success) {
    return (
      <div className={`nc-PageConfirmationEmail ${className}`} data-nc-id="PageConfirmationEmail">
      <Helmet>
        <title>{t('emailConfirmationTitle')}</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-10 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
        {t('emailConfirmationSuccess')}
        </h2>
        <div className="max-w-md mx-auto text-center space-y-3">
          <div>
           <p>
          {t('emailAccountActivated')}
        </p>
        <br/>
        <ButtonPrimary onClick={() => navigate(t('lienLogin'))}>
          {t('seConnecter')}
        </ButtonPrimary>
          </div>
   
        </div>
      </div>


    </div>
    );
  }

  if (messageErreur) {
  return (
       <div className={`nc-PageConfirmationEmail ${className}`} data-nc-id="PageConfirmationEmail">
      <Helmet>
        <title>{t('emailConfirmationTitle')}</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-10 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
        {t('emailInvalidLinkTitle')}
        </h2>
        <div className="max-w-md mx-auto text-center space-y-3">
          <div>
           <h1>{t('emailConfirmationImpossible')}</h1>
    <br/>
            <p>
              {messageErreur}
            </p>
    <br/>
            <ButtonPrimary onClick={() => navigate(t('lienLogin'))}>
              {t('emailBackToLogin')}
            </ButtonPrimary>
          </div>
   
        </div>
      </div>


    </div>

  );
 }

 return null;
};

export default PageConfirmationEmail;
